export default "__VITE_ASSET__BCNdvX9i__"